import React from "react";


const TermsAndConditions = () => {
  return (
    <div className="policy-page">
      <h1>Terms & Conditions</h1>
      <p>
        Welcome to <strong>Around the Globe</strong>. By using our website and
        services, you agree to the terms and conditions mentioned here.
      </p>

      <h2>1. Booking Rules</h2>
      <p>
        All travel bookings are subject to availability and confirmation.
        Refunds and cancellations depend on policies of each travel package.
      </p>

      <h2>2. User Responsibilities</h2>
      <p>
        You agree to provide accurate details for bookings and comply with local
        laws of your travel destination.
      </p>

      <h2>3. Limitation of Liability</h2>
      <p>
        While we ensure smooth arrangements, we are not responsible for delays,
        natural calamities, or external travel interruptions.
      </p>

      <h2>4. Changes to Terms</h2>
      <p>
        We may update the terms anytime. Continued usage of our services counts
        as acceptance of updates.
      </p>
    </div>
  );
};

export default TermsAndConditions;
